import { axiosClient } from "../api/axiosClient";
import type { CurrentMonthOutcome } from "../hooks/useCurrentMonthOutcomeQuery";

export const outcomeRepository = {
  async getCurrentMonth(
    terreiroId?: string,
    mediumId?: string,
    period?: { month: number; year: number },
  ): Promise<CurrentMonthOutcome> {
    const params = new URLSearchParams();

    if (period) {
      params.append("month", String(period.month));
      params.append("year", String(period.year));
    } else {
      params.append("period", "current_month");
    }

    if (terreiroId) {
      params.append("terreiroId", terreiroId);
    } else if (mediumId) {
      params.append("mediumId", mediumId);
    }

    const response = await axiosClient.get(`/outcome?${params.toString()}`, {
      withCredentials: true,
    });
    return response.data;
  },
};
